// extracted by mini-css-extract-plugin
export default {"app":"PayStar_app__CLWMr","back":"PayStar_back__KGdDk","box":"PayStar_box__99XBn"};